export default class Movie {
    constructor() {
        this.init();
    }

    init() {
        this.openMovie();
    }

    openMovie() {
        const movieBtn = [
            ...document.querySelectorAll(".movie__btn"),
        ];


        movieBtn.forEach((el) => {
            el.addEventListener("click", (e) => {
                e.preventDefault();

                const movieId = el.getAttribute("data-movie");
                const videoId = el.getAttribute("data-videoID");

                
                const movie = document.querySelector(".movie");
                const movieframe = document.querySelector(".movie__frame");
                const moviebg = document.querySelector(".movie__bg");
                const movieYoutube = document.querySelector(".movie__ph");

                moviebg.load();
                movieframe.setAttribute("src", `assets/mov/${movieId}.mp4`);
                moviebg.play();
                moviebg.loop = true;

                movieYoutube.setAttribute("data-videoID", videoId);
                movie.setAttribute("data-movie", movieId);
                
            });
        });

        
    }
}